import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import MyGarageCarsList from "../components/MyGarage/MyGarageCarsList";
import MyGarageCarDetail from "../components/MyGarage/MyGarageCarDetail";
import { useLogPageVisitMutation } from "../../../toolkit/appConfiguration/appConfigurationApi";

const MyGarage = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(null);
  // const [myCarsOrOtherCars, setMyCarsOrOtherCars] = React.useState(null);
  // useState variables end...

  const [logPageVisitApiHandler, logPageVisitApiData] = useLogPageVisitMutation();

  const Vehicle_Id = location?.pathname?.split?.(`${routes.myGarage}/`)?.[1];

  React.useEffect(() => {
    (async () => {
      await logPageVisitApiHandler({
        payload: {
          page_id: 1
        }
      });
    })();
  }, []);

  if (Vehicle_Id) {
    return <MyGarageCarDetail 
      selectedCarInit={selectedCar}
    />;
  }

  return <MyGarageCarsList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car, carStatus) => {
      setSelectedCar({
        ...car,
        car_label_status: carStatus ? carStatus : car?.car_label_status
      });
      navigate(`${routes.dashboardNavigation}${routes.myGarage}/${car?.Vehicle_Id}`);
    }}
  />;
};

export default MyGarage;
